import React, { useEffect, useRef } from 'react'
import mapboxgl from 'mapbox-gl'
import { Place } from '../../../models'
import { iconUrlForCategory } from '../../../util/placeCategoryIconMapping'
import { useMap } from '../mapbox/MapContext'

type Props = { place: Place }

const PlaceMarker: React.FC<Props> = ({ place }) => {
  const map = useMap()
  const markerRef = useRef<mapboxgl.Marker | null>(null)

  useEffect(() => {
    if (!map || !place.geo) return

    const el = document.createElement('div')
    el.className = ['place-marker', place.markerSize].join(' ')

    const img = document.createElement('img')
    img.className = 'place-marker-img'
    img.alt = ''
    img.src = iconUrlForCategory(place.category)
    el.appendChild(img)

    const offsetY = place.markerSize === 'large' ? -10 : -8

    const marker = new mapboxgl.Marker({ element: el, anchor: 'bottom', offset: [0, offsetY] })
      .setLngLat(place.geo.geometry.coordinates)
      .addTo(map)

    markerRef.current = marker

    return () => {
      marker.remove()
      markerRef.current = null
    }
  }, [map, place])

  return null
}

export default PlaceMarker
